import { render, staticRenderFns } from "./OtherPayments.vue?vue&type=template&id=187faaf4"
import script from "./OtherPayments.vue?vue&type=script&lang=js"
export * from "./OtherPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports